import { render, staticRenderFns } from "./VideoDeviceForm.vue?vue&type=template&id=d5f17040&"
import script from "./VideoDeviceForm.vue?vue&type=script&lang=js&"
export * from "./VideoDeviceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports